/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Date/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'



/** @type {import('Simple/types.js').View} */
export default function Date({
  children,
  viewPath = "/App/Account/Content/Content/Home/AppointmentBookings/Content/BookingDetails/DateTimeScheduled/Content/Date"
  
}) {
let appointmentAppointmentBookings0LocalStartDateValueData = fromData.useDataFormat({ viewPath,
context: 'appointment',
path: 'appointment_bookings[0].local_start_date',
format: fromFormat.dateShortInFull,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 data="appointment.appointment_bookings[0].local_start_date"
 format="/Data/format.js dateShortInFull"
 text={appointmentAppointmentBookings0LocalStartDateValueData}
 color="rgba(19,126,197,1)"
/>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 marginRight={dtSpaceXxs}
 text=","
 color="rgba(19,126,197,1)"
/>
{children}
</React.Fragment>)
}